import { createApp } from "vue";
import { createWebHistory, createRouter } from "vue-router";

// styles

import "@fortawesome/fontawesome-free/css/all.min.css";
import "@/assets/styles/tailwind.css";

// mouting point for the whole app

import App from "@/App.vue";

// layouts

import Admin from "@/layouts/Admin.vue";
import Auth from "@/layouts/Auth.vue";

// views for Admin layout

import Dashboard from "@/views/admin/Dashboard.vue";
import Settings from "@/views/admin/Settings.vue";
import Tables from "@/views/admin/Tables.vue";
import Maps from "@/views/admin/Maps.vue";

// views for Auth layout

import Login from "@/views/auth/Login.vue";
import Register from "@/views/auth/Register.vue";

// views without layouts

import Landing from "@/views/Landing.vue";
import Profile from "@/views/Profile.vue";
import contractdesign from "@/views/contract-design.vue";
import Index from "@/views/Index.vue";
import SoftwareServices from "./views/software-services.vue";
import SystemIntegration from "./views/system-integration.vue";
import devopsintegration from "@/views/devops-integration.vue";
import contactus from "./views/contactus.vue";
import Products from "./views/product.vue";
import partners from "./views/our-network.vue";
import industries from "./views/industries.vue";
import sustainabilityconsulting from "./views/sustainability-consulting.vue";
import Services from "./views/Services.vue";
import commingsoon from "./views/comming-soon.vue";
// routes

const routes = [
  {
    path: "/admin",
    redirect: "/admin/dashboard",
    component: Admin,
    children: [
      {
        path: "/admin/dashboard",
        component: Dashboard,
      },
      {
        path: "/admin/settings",
        component: Settings,
      },
      {
        path: "/admin/tables",
        component: Tables,
      },
      {
        path: "/admin/maps",
        component: Maps,
      },
    ],
  },
  {
    path: "/auth",
    redirect: "/auth/login",
    component: Auth,
    children: [
      {
        path: "/auth/login",
        component: Login,
      },
      {
        path: "/auth/register",
        component: Register,
      },
    ],
  },
  {
    path: "/landing",
    component: Landing,
  },
  {
    path: "/profile",
    component: Profile,
  },
  {
    path: "/contract-design",
    component: contractdesign,
  },
  {
    path: "/software-services",
    component: SoftwareServices,
  },
  {
    path: "/sustainability-consulting",
    component: sustainabilityconsulting,
  },
  {
    path: "/systems-integration",
    component: SystemIntegration,
  },
  {
    path: "/devops-integration",
    component: devopsintegration,
  },
  {
    path: "/contactus",
    component: contactus,
  },
  {
    path: "/products",
    component: Products,
  },
  {
    path: "/our-network",
    component: partners,
  },
  {
    path: "/industries",
    component: industries,
  },
  {
    path: "/services",
    component: Services,
  },
  {
    path: "/comming-soon",
    component: commingsoon,
  },
  {
    path: "/",
    component: Index,
  },
  { path: "/:pathMatch(.*)*", redirect: "/" },
];

// const router = createRouter({
//   history: createWebHistory(),
//   routes,
   

// });
  const router = createRouter({
  history: createWebHistory(),
  routes,

  scrollBehavior(to, from, savedPosition) {

    // Back/forward browser button
    if (savedPosition) {
      return savedPosition
    }

    // If URL contains #hash
    if (to.hash) {
      return {
        el: to.hash,
        behavior: 'smooth'
      }
    }

    // Normal route change → go to top
    return { top: 0 }
  }
});
createApp(App).use(router).mount("#app");